import React, { Component } from "react";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import { connect } from "react-redux";
import SearchResultHeader from "./SearchResultHeader";
import MarriageDivorceRecordDetail from "./MarriageDivorceRecordDetail";
import { getMenuItem } from "../common/PageHelper";

class MarriageDivorceResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    let tabHeader = null;
    let recLen = 0;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const records = _.get(
        this.props.searchResultData,
        `${Object.keys(this.props.searchResultData)[0]}.response`
      );
      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );
      recLen = parseInt(
        _.get(
          this.props.searchResultData,
          `${Object.keys(this.props.searchResultData)[0]}.log[0].actCode[0]`
        ),
        10
      );
      if (records !== undefined && recLen > 0) {
        // const marriages = _.get(records, "marriages[0].record");
        // const divorces = _.get(records, "divorces[0].record");
        // recLen =
        //   (marriages ? marriages.length : 0) + (divorces ? divorces.length : 0);
        _.forEach(records, (record, index) => {
          results.push(
            <Table.Row key={`MarDivo_Body_Table_Row_${index}`}>
              <Table.Cell>
                <MarriageDivorceRecordDetail
                  key={`MarDivo_Body_Table_${index}`}
                  node={record}
                  index={index}
                  {...this.props}
                />
              </Table.Cell>
            </Table.Row>
          );
        });
      } else {
        results.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }

    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recLen} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(MarriageDivorceResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/MarriageDivorceResult.js